import { globalStore } from "@/store/store-accessor";
import { jsonStringifyOrUndefined } from "@/util/json-stringify-or-undefined";
import { triggerDownload } from "@/util/trigger-download";

export function exportGlobalSettings() {
  const globalSettingsJson = jsonStringifyOrUndefined(
    globalStore.globalSettings
  );
  triggerDownload(globalSettingsJson || "", "global-settings.json");
}
